/**
* author: duxin
* date: 2020/4/7
* describe:头部导航
*/

<template>
	<header :class="[`m-header ${scrollTop ? 'scroll-top':'scroll-nav'}`, {'isScroll': !scrollFlag}]">
		<div class="nav-wrap">
			<!-- <img class="logo-web" v-if="scrollTop && scrollFlag" src="../assets/meta_lg.png"  @click="onGoHome"/>
			<img class="logo-web" v-if="!scrollTop" src="../assets/meta_lg.png"  @click="onGoHome"/> -->
			<img class="logo-web" src="../assets/meta_lg.png"  @click="onGoHome"/>
			<img class="logo-phone" src="../assets/meto-logo-phone.png"  @click="onGoHome"/>
			<div class="menu-web">
				<KMenu :menus="menuList" :scrollTop="scrollTop"></KMenu>
			</div>

			<KMenuPhone class="menu-phone" :menus="menuList" :scrollTop="scrollTop"></KMenuPhone>
		</div>
	</header>
</template>

<script>
import KMenu from './kllk-menu'
import KMenuPhone from './kllk-menu-phone'

export default {
	name: 'kllk-header-nav',
	components: { KMenu, KMenuPhone },
	props: {
		scrollTop: {
			type: Boolean, //是否滑到顶部
			delete: true,
		},
		scrollFlag: {
			type: Boolean, //首页导航显示
			default: false,
		},
	},
	data() {
		return {
			menuList: [
				{ title: this.$t('menu.about'), path: '/home' },
				{
					title: this.$t('menu.service'),
					path: '/service',
					children: [
						{ title: this.$t('menu.dm'), path: '/service/dm' },
						{
							title: this.$t('menu.biostatistics'),
							path: '/service/biostatistics',
						},
						{ title: this.$t('menu.sp'), path: '/service/sp' },
						// {
						// 	title: this.$t('menu.pharmacovigilance'),
						// 	path: '/service/pharmacovigilance',
						// },
						// { title: this.$t('menu.cc'), path: '/service/cc' },
					],
				},
				{
					title: this.$t('menu.info'),
					path: '/info',
					children: [
						{
							title: this.$t('menu.company'),
							path: '/info/company',
						},
						{
							title: this.$t('menu.industry'),
							path: '/info/industry',
						},
						// {title: this.$t("menu.book"), path: "/info/book"}
					],
				},
				{
					title: this.$t('menu.contact'),
					path: '/about',
				},
				// {title: this.$t("menu.job"), path: "/join"},
				// {title: this.$t("menu.contact"), path: "/contact"},
				{ title: this.$t('menu.lang'), path: '', call: this.onLang },
			],
		}
	},
	methods: {
		onShowMenu() {},
		onLang() {
			let language = sessionStorage.getItem('language')
			if (language === 'en') {
				sessionStorage.setItem('language', 'zh')
			} else {
				sessionStorage.setItem('language', 'en')
			}
			window.location.reload()
		},
		onGoHome() {
			this.$router.push({
				name: "HOME"
			})
		}
	},
}
</script>

<style lang="less" scoped>
@import '../style/constant.less';

.m-header {
	position: fixed;
	top: 0;
	z-index: 200;
	width: 100%;
	// box-shadow: 0 1px 5px rgba(8, 37, 143, 0.2);
	transition: background-color 0.3s;

	.nav-wrap {
		width: @page-width;
		margin: 0 auto;
		display: flex;
		align-items: center;
		height: 70px;
		justify-content: space-between;

		img {
			max-height: 60px;
		}
		.logo-web {
			cursor: pointer;
		}
	}

	@media screen and (min-width: 320px) and (max-width: 480px) {
		.nav-wrap {
			width: 90%;
			margin: 0 10px !important;

			img {
				max-height: 60px;
				max-width: 300px;
			}
			.menu-web {
				display: none;
			}
			.logo-web {
				display: none;
			}
			.logo-phone {
				display: block;
				// height: 50px;
			}
			.menu-phone {
				display: block;
				color: #435ba1;
			}
		}
	}
}

.scroll-top {
	box-shadow: none;
	background-color: #3a4e64;
}
// 其他模块导航栏样式
.scroll-nav {
	background-color: #3a4e64;
}
// 首页导航
.isScroll {
	position: fixed;
	.menu-phone {
		color: #ffffff;
	}
}

.menu-web {
	height: 100%;
}

.menu-phone {
	display: none;
}

.logo-phone {
	display: none;
	height: 50px;
}

/*-----element-----*/

.el-menu.el-menu--horizontal {
	background-color: transparent;
	border-bottom: none;
}

.el-menu-item {
	padding: 0 10px;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
	padding: 0 10px;
}
</style>
